/* eslint-disable no-unused-vars */
import { createStructuredSelector } from 'reselect';
import { complement, compose, find, identity, isNil, path } from 'lodash/fp';

const TAX_TYPE_REGISTERED = 0;
const TAX_TYPE_ASSOCIATED = 1;
const TAX_TYPE_ADDED = 2;

export const findRegisteredTax = find({ type: TAX_TYPE_REGISTERED });

const getSuccessorTaxCode = path('successor.taxCode');
const getSuccessorTaxName = path('successor.taxCodeName');
const getSuccessorTaxStatus = path('successor.isTaxCodeActive');
const getSuccessorTaxSuccessorCode = path('successor.taxCodeSuccessor');
const getSuccessorTaxSuccessorName = path('successor.taxCodeSuccessorName');

export const isTaxCodeActive = compose(identity, getSuccessorTaxStatus);
export const hasTaxCodeSuccessor = compose(complement(isNil), getSuccessorTaxSuccessorCode);

export const getTaxAuthorityCode = path('taxAuthority.code');

export const evolveTax = createStructuredSelector({
  code: getSuccessorTaxCode,
  name: getSuccessorTaxName,
});

export const evolveTaxSuccessor = createStructuredSelector({
  code: getSuccessorTaxSuccessorCode,
  name: getSuccessorTaxSuccessorName,
});
